import { render, staticRenderFns } from "./ModalSoldOut.vue?vue&type=template&id=3516c24e"
import script from "./ModalSoldOut.vue?vue&type=script&lang=js"
export * from "./ModalSoldOut.vue?vue&type=script&lang=js"
import style0 from "./ModalSoldOut.vue?vue&type=style&index=0&id=3516c24e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports